<router-outlet></router-outlet>
<app-auth-modal></app-auth-modal>
<app-promote-modal></app-promote-modal>

<div *ngIf="newMessages && newMessages.length > 0" class="new-messages">
  <ng-container *ngFor="let message of newMessages | slice: -4">
    <div class="new-message" (click)="openMessageRoom(message)">
      <div class="author">{{ message.fromFullName }}</div>
      <div class="content">{{ message.subjectPreview }}</div>
      <div class="close" (click)="removeMessage(message)">
        <ng-icon name="featherXCircle"></ng-icon>
      </div>
    </div>
  </ng-container>
</div>
